import React from "react";
import Button from "./Button";
import { FiXSquare } from "react-icons/fi";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { useSelector } from "react-redux";
import {
  isButtonProcessing,
  getButtonProcessingClass,
} from "../../utils/common-utils";

const ButtonReject = (props) => {
  const buttonProcessingState = useSelector((state) => state.button_processing);
  const isProcessing = isButtonProcessing(buttonProcessingState, props);
  const processingClass = getButtonProcessingClass(isProcessing);
  const tmpProps = {
    ...props,
    theme: tenkenTheme.button,
    color: "red",
    className: `w-[164px] ${props.className} ${processingClass}`,
  };
  return (
    <Button {...tmpProps}>
      <FiXSquare className="mr-[4px]" size={20} />
      {props.children}
    </Button>
  );
};

export default ButtonReject;
